{
  "id": "hoge-huis-nieuwe-brug",
  "source": "quay-damrak-west",
  "sourceRefs": [
    "painting-1538",
    "woodcut-1544",
    "https://www.theobakker.net/pdf/Victoriahotel-huisjes-vEeghen.pdf"
  ],
  "notes": "Van Eeghen (1966), pp. 129\u2013130, identifies a lower corner house and a much taller, deep house along the Damrak in both Anthonisz images, with timber yards behind and beside them. This is an estimated ground fit to the retained western Damrak and IJ quays, not a measured cadastral plan. Chainages, widths, depths, floors, openings, roof pitches and timber arrangements are estimates. The existing defensive bridge tower remains a separate object; the later residential turret and 1688 facade are not copied into 1538.",
  "houses": [
    {
      "id": "hoge-huis-estimated/corner",
      "chainage": 7,
      "width": 6.5,
      "depth": 14,
      "storeys": 2,
      "storeyHeight": 3.3,
      "roofRise": 4.4,
      "roofMaterial": "tile",
      "yardWindows": {
        "fromFront": [3.5, 9.5],
        "width": 0.75,
        "height": 1.4,
        "sill": 0.95
      }
    },
    {
      "id": "hoge-huis-estimated/high",
      "chainage": 15,
      "width": 9,
      "depth": 27,
      "storeys": 4,
      "storeyHeight": 3,
      "roofRise": 7,
      "roofMaterial": "slate",
      "yardWindows": {
        "fromFront": [16, 21, 25],
        "width": 0.75,
        "height": 1.4,
        "sill": 0.95
      }
    }
  ],
  "adjoiningFrontage": {
    "id": "hoge-huis-adjoining-frontage",
    "notes": "The images show houses continuing south along the Damrak, without the broad open strip left by the two modelled rows. These three individually authored bodies are a provisional division of that obscured frontage, not three recovered cadastral parcels or an extension of the documented Hoge Huis ownership. All dimensions, divisions, heights and roof materials are estimates; the street and the existing recorded row are retained.",
    "houses": [
      {
        "id": "hoge-huis-estimated/adjoining-01",
        "chainage": 23.5,
        "width": 7.5,
        "depth": 23,
        "storeys": 2,
        "storeyHeight": 3.2,
        "roofRise": 4.7,
        "roofMaterial": "tile"
      },
      {
        "id": "hoge-huis-estimated/adjoining-02",
        "chainage": 31.5,
        "width": 7.5,
        "depth": 23,
        "storeys": 3,
        "storeyHeight": 3,
        "roofRise": 5.1,
        "roofMaterial": "tile"
      },
      {
        "id": "hoge-huis-estimated/adjoining-03",
        "chainage": 39.5,
        "width": 7,
        "depth": 23,
        "storeys": 2,
        "storeyHeight": 3.2,
        "roofRise": 4.8,
        "roofMaterial": "tile"
      }
    ]
  },
  "privateGround": [
    [329, 454],
    [353, 452],
    [365, 462],
    [353, 485],
    [342, 484],
    [327, 471]
  ],
  "timber": [
    {
      "id": "hoge-huis-timber/east",
      "at": [355, 474],
      "yaw": 2.26,
      "width": 3.4,
      "depth": 1.8,
      "height": 6.1,
      "boards": 9
    },
    {
      "id": "hoge-huis-timber/north",
      "at": [350, 480],
      "yaw": 2.26,
      "width": 3.6,
      "depth": 1.8,
      "height": 5.4,
      "boards": 10
    },
    {
      "id": "hoge-huis-timber/west",
      "at": [342, 477],
      "yaw": 2.26,
      "width": 4,
      "depth": 1.8,
      "height": 5.8,
      "boards": 11
    },
    {
      "id": "hoge-huis-timber/inner",
      "at": [333, 465],
      "yaw": 2.26,
      "width": 3.8,
      "depth": 1.8,
      "height": 4.8,
      "boards": 10
    }
  ]
}
